import * as React from 'react';

import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { apiClientFactory } from '../../api';

import { ISkinAnalyzerEvents } from './model';
import { updateCartHeader, updateWishlistHeader } from './utils';

export interface ISkinAnalyzerEventProps {
  events: ISkinAnalyzerEvents;
}

export const useSkinAnalyzerEvents = (): ISkinAnalyzerEventProps => {
  const {
    skinAnalyzer: { apiUrl },
  } = useApolloClientHeaders();
  const { addToCart, addToWishlist, removeFromWishlist } = React.useMemo(
    () =>
      apiClientFactory({
        apiUrl,
      }),
    [apiUrl]
  );

  const events = React.useMemo(() => {
    return {
      onAddToCart: async (products) => {
        await Promise.allSettled(
          products.map((product) => addToCart(product.id))
        );

        updateCartHeader();
      },
      onAddToFavorites: async (productId) => {
        await addToWishlist(productId);
        updateWishlistHeader();
      },
      onRemoveFromFavorites: async (productId) => {
        await removeFromWishlist(productId);
        updateWishlistHeader();
      },
      onCheckout: () =>
        window.location.assign(`${window.location.origin}/cart`),
      onClickProduct: (product) => window.location.assign(product.url),
      onExpandProduct: (_) => null,
    } as ISkinAnalyzerEvents;
  }, [addToCart, addToWishlist, removeFromWishlist]);

  return { events };
};
